
// ==========================================
// frontend/src/components/SearchBar.jsx
import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import { search as apiSearch } from '../services/api';
import { useNavigate } from 'react-router-dom';

const SearchBar = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(null);
  const [ setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    try {
      const response = await apiSearch({ q: query });
      setResults(response.data);
      setShowResults(true);
    } catch (error) {
      console.error('Erreur de recherche:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleResultClick = (type, id) => {
    setShowResults(false);
    setQuery('');
    navigate(`/${type}/${id}`);
  };

  return (
    <div className="relative">
      <form onSubmit={handleSearch} className="relative">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Rechercher..."
          className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-600 transition-colors"
        >
          <FaSearch />
        </button>
      </form>

      {showResults && results && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg max-h-96 overflow-y-auto z-50">
          {results.services?.length > 0 && (
            <div className="p-4">
              <h3 className="font-semibold text-gray-700 mb-2">Services</h3>
              {results.services.map((service) => (
                <div
                  key={service._id}
                  onClick={() => handleResultClick('services', service._id)}
                  className="p-2 hover:bg-gray-100 cursor-pointer rounded"
                >
                  <p className="font-medium">{service.title}</p>
                  <p className="text-sm text-gray-600 truncate">{service.description}</p>
                </div>
              ))}
            </div>
          )}

          {results.realizations?.length > 0 && (
            <div className="p-4 border-t">
              <h3 className="font-semibold text-gray-700 mb-2">Réalisations</h3>
              {results.realizations.map((realization) => (
                <div
                  key={realization._id}
                  onClick={() => handleResultClick('realizations', realization._id)}
                  className="p-2 hover:bg-gray-100 cursor-pointer rounded"
                >
                  <p className="font-medium">{realization.title}</p>
                  <p className="text-sm text-gray-600 truncate">{realization.description}</p>
                </div>
              ))}
            </div>
          )}

          {!results.services?.length && !results.realizations?.length && (
            <div className="p-4 text-center text-gray-500">
              Aucun résultat trouvé
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
